import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Caixa } from './Caixa';
import { Automacoes } from './Automacoes';
import { ChatSite } from './ChatSite';
import { Filas } from './Filas';
import { RespostasRapidas } from './RespostasRapidas';
import { Templates } from './Templates';
import { i18n } from './i18n';
import { buscaConversas } from './busca-global';

const modulo: ModuloWeb = {
  slug: 'conversas',
  menu: 'comercial',
  ordem: 20,
  abas: [
    { chave: 'whatsapp', permissao: 'conversas.ver', componente: () => <Caixa key="whatsapp" canal="whatsapp" /> },
    { chave: 'instagram', permissao: 'conversas.ver', componente: () => <Caixa key="instagram" canal="instagram" /> },
    { chave: 'email', permissao: 'conversas.ver', componente: () => <Caixa key="email" canal="email" /> },
    // Portal do Cliente (Onda 1): mensagens do app "Malgo" do cliente, na mesma caixa, filas e avisos.
    { chave: 'portal', permissao: 'conversas.ver', componente: () => <Caixa key="portal" canal="portal" /> },
    // Item 11 do lote de 19/10: conversas do chat do site (widgets em vários domínios), na mesma caixa e filas.
    { chave: 'site', permissao: 'conversas.ver', componente: () => <Caixa key="site" canal="site" /> },
    { chave: 'respostas-rapidas', permissao: 'conversas.ver', componente: RespostasRapidas },
    { chave: 'templates', avancada: true, permissao: 'conversas.ver', componente: Templates },
    { chave: 'filas', avancada: true, permissao: 'conversas.ver', componente: Filas },
    // Trilha 5b (Digisac): menu de entrada por canal e respostas por palavra-chave.
    { chave: 'automacoes', avancada: true, permissao: 'conversas.ver', componente: Automacoes },
    // Item 11 do lote de 19/10: cadastro dos widgets do chat do site (domínios, fila, cor, saudação, LGPD e o código).
    { chave: 'chat-site', avancada: true, permissao: 'conversas.ver', componente: ChatSite },
  ],
  i18n,
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaConversas,
};

export default modulo;
